/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */

export type BulkReprocessRunDtoMode = typeof BulkReprocessRunDtoMode[keyof typeof BulkReprocessRunDtoMode];


export const BulkReprocessRunDtoMode = {
  FAILED: 'FAILED',
  ALL: 'ALL',
  RESEND: 'RESEND',
} as const;
